import State from '../interfaces/states/DatePickersState';

import * as moment from 'moment';

import * as Const from '../constants';

const initState: State = {
  dateStart: moment().subtract(7, 'd'),
  dateEnd: moment(),
  isLoading: false,
  isError: false,
  focusedInput: null,
  hideDatePicker: false,
};

export default function datepickers (state: State = initState, action): State {
  switch (action.type) {

    case Const.FETCH_DATEPICKERS_INIT:
      return {
        ...initState,
      };

    case Const.FETCH_DATEPICKERS_HIDE:
      return {
        ...state,
        hideDatePicker: true,
      };

    case Const.FETCH_DATEPICKERS_SHOW:
      return {
        ...state,
        hideDatePicker: false,
      };

    case Const.FETCH_DATEPICKERS_PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case Const.FETCH_DATEPICKERS_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
      };

    case Const.FETCH_DATEPICKERS_START_DATE:
      return {
        ...state,
        dateStart: action.payload,
      };

    case Const.FETCH_DATEPICKERS_END_DATE:
      return {
        ...state,
        dateEnd: action.payload,
      };

    default:
      return state;
  }
}
